var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-list',{attrs:{"bordered":"","separator":""}},_vm._l((_vm.publications),function(pub){return _c('author-publication',{key:pub.id,attrs:{"publication":pub}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }